export default function makeIdSafe(sourceString) {
  return sourceString.replace(/\s+/g, '-').replace(/^-/, '').replace(/-$/, '').toLocaleLowerCase();
}
